import React, { useEffect, useRef, useState } from "react";
import "./Header.css";
import { useDispatch, useSelector } from "react-redux";
import { translate, toggleDarkMode } from "../../store/actions.js";
import LoginModal from "../admin/LoginModal";

const Header = ({ session, onAdminClick }) => {
  const [Toggle, showMenu] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showLang, setShowLang] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const langRef = useRef(null);

  const dispatch = useDispatch();
  const en_es = useSelector((state) => state.translation);
  const isDark = useSelector((state) => state.darkMode);

  const translateWeb = () => {
    dispatch(translate());
  };

  const handleLanguageChange = (targetLanguage) => {
    const isEnglishSelected = targetLanguage === "en";

    if (en_es !== isEnglishSelected) {
      translateWeb();
    }

    setShowLang(false);

    if (window.innerWidth <= 768) {
      showMenu(false);
    }
  };

  const toggleTheme = () => {
    dispatch(toggleDarkMode());
  };

  useEffect(() => {
    localStorage.setItem("darkMode", isDark ? "true" : "false");
  }, [isDark]);

  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector(".header");
      if (!header) {
        return;
      }

      if (window.scrollY >= 10) {
        header.classList.add("show-header");
      } else {
        header.classList.remove("show-header");
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handler = (event) => {
      if (langRef.current && !langRef.current.contains(event.target)) {
        setShowLang(false);
      }
    };

    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => {
    const sections = document.querySelectorAll("section[id]");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { rootMargin: "-40% 0px -55% 0px" },
    );

    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  return (
    <header className="header">
      <nav className="nav container">
        <a href="index.html" className="nav__logo" aria-label="Home"></a>

        <div className={Toggle ? "nav__menu show-menu" : "nav__menu"}>
          <div className="nav__groups">
            <ul className="nav__list nav__list--primary grid">
              <li className="nav__item">
                <a
                  href="#home"
                  className={`nav__link${activeSection === "home" ? " active-link" : ""}`}
                >
                  <i className="uil uil-estate nav__icon"></i>
                  {en_es ? "Home" : "Inicio"}
                </a>
              </li>

              <li className="nav__item">
                <a
                  href="#about"
                  className={`nav__link${activeSection === "about" ? " active-link" : ""}`}
                >
                  <i className="uil uil-user nav__icon"></i>
                  {en_es ? "About" : "Sobre mí"}
                </a>
              </li>

              <li className="nav__item">
                <a href="#about" className="nav__link">
                  <i className="uil uil-message nav__icon"></i>
                  CV
                </a>
              </li>

              <li className="nav__item">
                <a
                  href="#skills"
                  className={`nav__link${activeSection === "skills" ? " active-link" : ""}`}
                >
                  <i className="uil uil-file nav__icon"></i>
                  {en_es ? "Skill" : "Habilidades"}
                </a>
              </li>

              <li className="nav__item">
                <a
                  href="#github"
                  className={`nav__link${activeSection === "github" ? " active-link" : ""}`}
                >
                  <i className="uil uil-github nav__icon"></i>
                  GitHub
                </a>
              </li>

              <li className="nav__item">
                <a
                  href="#projects"
                  onClick={() => window.scroll(0, 3100)}
                  className={`nav__link${activeSection === "projects" ? " active-link" : ""}`}
                >
                  <i className="uil uil-file nav__icon"></i>
                  {en_es ? "Projects" : "Proyectos"}
                </a>
              </li>

              <li className="nav__item">
                <a
                  href="#courses"
                  className={`nav__link${activeSection === "courses" ? " active-link" : ""}`}
                >
                  <i className="uil uil-graduation-cap nav__icon"></i>
                  {en_es ? "Courses" : "Cursos"}
                </a>
              </li>

              <li className="nav__item">
                <a
                  href="#testimonials"
                  className={`nav__link${activeSection === "testimonials" ? " active-link" : ""}`}
                >
                  <i className="uil uil-comment-heart nav__icon"></i>
                  {en_es ? "Reviews" : "Opiniones"}
                </a>
              </li>

              <li className="nav__item">
                <a
                  href="#currently-working"
                  className={`nav__link${activeSection === "currently-working" ? " active-link" : ""}`}
                >
                  <i className="uil uil-briefcase-alt nav__icon"></i>
                  {en_es ? "Current Work" : "En desarrollo"}
                </a>
              </li>

              <li className="nav__item">
                <a
                  href="#qualifications"
                  className={`nav__link${activeSection === "qualifications" ? " active-link" : ""}`}
                >
                  <i className="uil uil-file nav__icon"></i>
                  {en_es ? "Experience" : "Experiencia"}
                </a>
              </li>

              <li className="nav__item">
                <a
                  href="#contact"
                  className={`nav__link${activeSection === "contact" ? " active-link" : ""}`}
                >
                  <i className="uil uil-message nav__icon"></i>
                  {en_es ? "Contact" : "Contacto"}
                </a>
              </li>

              <li className="nav__item">
                <a
                  href="#faq"
                  className={`nav__link${activeSection === "faq" ? " active-link" : ""}`}
                >
                  <i className="uil uil-question-circle nav__icon"></i>
                  FAQ
                </a>
              </li>
            </ul>

            <div className="nav__side">
              <span className="nav__separator" aria-hidden="true">
                |
              </span>

              <ul className="nav__list nav__list--secondary">
                <li
                  className="nav__item nav__lang nav__lang--desktop"
                  ref={langRef}
                >
                  <span
                    className="nav__link nav__lang-btn"
                    onClick={() => setShowLang((value) => !value)}
                  >
                    <i className="uil uil-globe nav__icon"></i>
                    {en_es ? "Language" : "Idioma"}
                    <i
                      className={`uil uil-angle-${showLang ? "up" : "down"} nav__lang-arrow`}
                    ></i>
                  </span>
                  {showLang && (
                    <ul className="nav__lang-dropdown">
                      <li
                        className={`nav__lang-option${!en_es ? " nav__lang-option--active" : ""}`}
                        onClick={() => handleLanguageChange("es")}
                      >
                        🇪🇸 Español
                      </li>
                      <li
                        className={`nav__lang-option${en_es ? " nav__lang-option--active" : ""}`}
                        onClick={() => handleLanguageChange("en")}
                      >
                        🇬🇧 English
                      </li>
                    </ul>
                  )}
                </li>

                <li className="nav__item nav__lang-mobile">
                  <div className="nav__lang-mobile-actions">
                    <button
                      type="button"
                      className={`nav__lang-mobile-btn${!en_es ? " nav__lang-mobile-btn--active" : ""}`}
                      onClick={() => handleLanguageChange("es")}
                    >
                      ES
                    </button>
                    <button
                      type="button"
                      className={`nav__lang-mobile-btn${en_es ? " nav__lang-mobile-btn--active" : ""}`}
                      onClick={() => handleLanguageChange("en")}
                    >
                      EN
                    </button>
                  </div>
                </li>

                <li className="nav__item">
                  <span
                    className="nav__link nav__theme-toggle"
                    onClick={toggleTheme}
                    style={{ cursor: "pointer" }}
                    aria-label={
                      isDark ? "Activate light mode" : "Activate dark mode"
                    }
                    title={isDark ? "Light mode" : "Dark mode"}
                  >
                    <i
                      className={`uil ${isDark ? "uil-sun" : "uil-moon"} nav__icon nav__theme-icon`}
                    ></i>
                  </span>
                </li>

                {session ? (
                  <li className="nav__item">
                    <span
                      onClick={onAdminClick}
                      style={{ cursor: "pointer" }}
                      className="nav__link nav__link--admin"
                    >
                      <i className="uil uil-shield-check nav__icon"></i>
                      Admin
                    </span>
                  </li>
                ) : (
                  <li className="nav__item">
                    <span
                      onClick={() => setShowLogin(true)}
                      style={{ cursor: "pointer" }}
                      className="nav__link nav__link--admin"
                    >
                      <i className="uil uil-lock nav__icon"></i>
                    </span>
                  </li>
                )}
              </ul>
            </div>

            <i
              className="uil uil-times nav__close"
              onClick={() => showMenu(!Toggle)}
            ></i>
          </div>
        </div>

        <div className="nav__toggle" onClick={() => showMenu(!Toggle)}>
          <i className="uil uil-bars"></i>
        </div>
      </nav>

      {showLogin && <LoginModal onClose={() => setShowLogin(false)} />}
    </header>
  );
};

export default Header;
